// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3T4qm","resendInfoText":"OnGoingPaymentBox_resendInfoText__dNQj5"};